import { render, staticRenderFns } from "./pending-doctors.vue?vue&type=template&id=190407e4&"
import script from "./pending-doctors.vue?vue&type=script&lang=js&"
export * from "./pending-doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports